<template>
  <v-container>
    <div class="center-box">
      <div class="login">
        <v-layout row wrap>
          <v-flex>
            <v-layout row column>
                <img src="@/assets/images/logo-cc-tu.png" alt="Logo" class="mx-auto mb-10" width="95px">
                <div class="text-xs-center">
                  <h2 class="h3">Comfort Commodity</h2>
                  <p class="mb-30"><strong>Investiční zlato a stříbro</strong></p>
                </div>
            </v-layout>
          </v-flex>
        </v-layout>
        <h4 class="mb-20 mt-0">Obnovení hesla</h4>
        <div v-if="!verifing_token && !verifing_token_error">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field hide-details solo class="ma-0 mb-20" label="E-mail" type="email" v-model="email" :rules="[ e => !!e || 'E-mailová adresa je vyžadována' ]" @keyup.native.enter="submit"></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="sent">
                <p class="green--text bold mt-3 mb-3">
                  Odkaz pro aktivaci Vám byl odeslán na e-mail.
                </p>
              </v-flex>
              <v-flex xs12 v-if="errorText != null">
                <p class="red--text bold mt-3 mb-3">
                  {{errorText}}
                </p>
              </v-flex>
              <v-flex xs12>
                <v-btn color="orange" class="elevation-0 button button-login ma-0" dark @click="submit" :loading="sending">Odeslat na e-mail</v-btn>
              </v-flex>
            </v-layout>
            <v-flex xs12 class="mt-2">
              <button-link color="grey" flat :to="{ path: '/' }">Zpět na přihlášení</button-link>
            </v-flex>
          </v-form>
        </div>
        <div v-else>
          <p class="mt-3 mb-3" v-if="!verifing_token_error">Probíhá ověřování...</p>
          <p class="mt-3 mb-3 red--text" v-else>Odkaz nemohl být ověřen, zkontrolujte prosím, za máte správný odkaz.</p>
          <button-link color="grey" flat :to="{ path: '/' }" v-if="verifing_token_error">Zpět na přihlášení</button-link>
        </div>
      </div>
      <v-footer class="login-footer">
        <v-layout row wrap>
          <v-flex xs12 sm12 text-center>
            <img src="@/assets/images/logo-cc-tu.png" alt="Logo" class="mx-auto" width="95px">
            <h3 class="mb-2">Comfort Commodity</h3>
            <h4>
              <a class="link-black" href="tel:+420734232022">+420 734 232 022</a> <br>
              <a class="link-black" href="mailto:info@comfort-commodity.cz">info@comfort-commodity.cz</a></h4>
            <!-- <p class="mb-0"><strong>&copy; Comfort Commodity 2019</strong></p> -->
          </v-flex>
        </v-layout>
      </v-footer>
    </div>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      rules: {
        required: value => !!value || 'Vyžadováno.',
        emailMatch: () => ('Email, který jste zadali není správně.')
      },
      valid: true,
      loading: false,
      passHidden: true,
      login: '',
      password: '',
      errorText: null,
      email: null,
      sending: false,
      sent: false
    }
  },
  props: {
    verifing_token: Boolean,
    verifing_token_error: Boolean
  },
  methods: {
    submit () {
      if (this.$refs.form.validate()) {
        this.$data.errorText = null;
        this.$data.sending = true;
        this.sent = false;
        window.API.post("session/obnovit-heslo", {
            email: this.email
        }).then(function(body) {
          if (body.status) {
            //window.API.$setCookie("hn_org", body.UID.toString(), { expires: 30, path: "/" });
            this.sent = true;
          }
          else {
            this.errorText = 'Obnovení hesla nemohlo být dokončeno.';
          }
          this.sending = false;
        }.bind(this)).catch(function(err) {
          this.sending = false;
          this.errorText = 'Obnovení hesla nemohlo být dokončeno.';
        }.bind(this));
      }
    }
  }
}
</script>
